import SalesBudgetMonthLayout from './salesBudgetMonthLayout';

export default SalesBudgetMonthLayout;
